export default __webpack_public_path__ + "static/media/pro-elevate-wht-2.dcb6419e.png";